import React, { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ToastNotification from './ToastNotification';
import './ToastNotifications.css';

const ToastNotificationProvider = () => {
  const toastNotifications = useSelector((state) => state.ui.sharedPages.toastNotifications);
  const dispatch = useDispatch();

  return (
    <div className={'Toast_Notification_Globe'}>
      <div className={'Toast_Notification_Wrapper'}>
        {toastNotifications &&
          Object.keys(toastNotifications).map((noteId) => {
            return <ToastNotification dispatch={dispatch} key={noteId} {...toastNotifications[noteId]} />;
          })}
      </div>
    </div>
  );
};

export default memo(ToastNotificationProvider);
